import { initClientErrorReporter, reportClientError } from '~/utils/reportClientError'

export default defineNuxtPlugin({
  name: 'client-error-log',
  enforce: 'post',
  setup(nuxtApp) {
    const config = useRuntimeConfig()
    const shopApi = useShopApiBase()

    initClientErrorReporter(() => {
      if (window.location.pathname.startsWith('/platform')) {
        return `${String(config.public.platformApiUrl || '').replace(/\/$/, '')}/client-errors`
      }
      return `${String(shopApi.value || '').replace(/\/$/, '')}/client-errors`
    })

    const previous = nuxtApp.vueApp.config.errorHandler
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
      reportClientError(error, { source: `vue:${info || 'errorHandler'}` })
      if (typeof previous === 'function') {
        previous(error, instance, info)
      }
    }

    if (!import.meta.client) return

    window.addEventListener('error', (event) => {
      reportClientError(event.error || event.message, { source: 'window.onerror' })
    })
    window.addEventListener('unhandledrejection', (event) => {
      reportClientError(event.reason, { source: 'unhandledrejection' })
    })
  },
})
